import { TransitionablePortal, Message } from 'semantic-ui-react';

import * as Styles from './confirmation-message.module.less';

export interface ConfirmationMessageInterface {
    open: boolean;
    message?: string;
    interact?: () => void;
    interactionMessage?: string;
}

export const ConfirmationMessage = (props: ConfirmationMessageInterface) => (
    <TransitionablePortal
        open={props.open}
        closeOnTriggerClick={false}
        closeOnDocumentClick={false}
        closeOnEscape={false}
        transition={{
            animation: 'slide up',
            duration: 200,
        }}
    >
        <div className={Styles.confirmationMessageContainer}>
            <Message floating size="small" className={Styles.confirmationMessage}>
                <div className={Styles.confirmationMessageContentContainer}>
                    <p>{props.message}</p>
                    {props.interact && (
                        <span onClick={props.interact}>
                            {props.interactionMessage ? props.interactionMessage : 'DISMISS'}
                        </span>
                    )}
                </div>
            </Message>
        </div>
    </TransitionablePortal>
);
